export default "__VITE_ASSET__ZuS6lQWt__"